 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01COVER from '@/components/001Cover'
 import A02HALF_TITLE from '@/components/002Half_Title'
 import A03TITLE_PAGE from '@/components/003Title_Page'
 import A04COPYRIGHT from '@/components/004Copyright'
 import A05DEDICATION from '@/components/005Dedication'
 import A06CONTENTS from '@/components/006Contents'
 import A07LIST_OF_ILLUSTRATIONS from '@/components/007List_of_Illustrations'
 import A08PREFACE from '@/components/008Preface'
 import A09INTRODUCTION from '@/components/009Introduction'
 import A101_THE_EXPEDITION_TO_JERUSALEM from '@/components/0101_The_Expedition_to_Jerusalem'
 import A112_SYRIA_AND_PALESTINE from '@/components/0112_Syria_and_Palestine'
 import A123_THE_FIRST_SETTLERS from '@/components/0123_The_First_Settlers'
 import A134_THE_ORIGINS_OF_THE_LATIN_STATES from '@/components/0134_The_Origins_of_the_Latin_States'
 import A145_THE_MILITARY_INSTITUTIONAL_AND_ECCLESIASTICAL_FRAMEWORK from '@/components/0145_The_Military_Institutional_and_Ecclesiastical_Framework'
 import A156_ANTIOCH_AND_JERUSALEM from '@/components/0156_Antioch_and_Jerusalem'
 import A167_THE_SECOND_GENERATION from '@/components/0167_The_Second_Generation'
 import A178_THE_ZENGID_THREAT from '@/components/0178_The_Zengid_Threat'
 import A189_THE_FRANKISH_IMPRINT from '@/components/0189_The_Frankish_Imprint'
 import A1910_KING_AMALRIC from '@/components/01910_King_Amalric'
 import A2011_THE_DISINTEGRATION_OF_THE_CRUSADER_STATES from '@/components/02011_The_Disintegration_of_the_Crusader_States'
 import A2112_THE_BATTLE_OF_HATTIN_AND_ITS_CONSEQUENCES from '@/components/02112_The_Battle_of_Hattin_and_its_Consequences'
 import A2213_THE_THIRD_CRUSADE from '@/components/02213_The_Third_Crusade'
 import A23CONCLUSION from '@/components/023Conclusion'
 import A24CHRONOLOGY from '@/components/024Chronology'
 import A25ABBREVIATIONS from '@/components/025Abbreviations'
 import A26NOTES from '@/components/026Notes'
 import A27FURTHER_READING from '@/components/027Further_Reading'
 import A28BIBLIOGRAPHY from '@/components/028Bibliography'
 import A29INDEX from '@/components/029Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/001Cover",
 			"name" : "001Cover",
 			"component" : A01COVER
 		},
 		{
 			"path" : "/002Half_Title",
 			"name" : "002Half_Title",
 			"component" : A02HALF_TITLE
 		},
 		{
 			"path" : "/003Title_Page",
 			"name" : "003Title_Page",
 			"component" : A03TITLE_PAGE
 		},
 		{
 			"path" : "/004Copyright",
 			"name" : "004Copyright",
 			"component" : A04COPYRIGHT
 		},
 		{
 			"path" : "/005Dedication",
 			"name" : "005Dedication",
 			"component" : A05DEDICATION
 		},
 		{
 			"path" : "/006Contents",
 			"name" : "006Contents",
 			"component" : A06CONTENTS
 		},
 		{
 			"path" : "/007List_of_Illustrations",
 			"name" : "007List_of_Illustrations",
 			"component" : A07LIST_OF_ILLUSTRATIONS
 		},
 		{
 			"path" : "/008Preface",
 			"name" : "008Preface",
 			"component" : A08PREFACE
 		},
 		{
 			"path" : "/009Introduction",
 			"name" : "009Introduction",
 			"component" : A09INTRODUCTION
 		},
 		{
 			"path" : "/0101_The_Expedition_to_Jerusalem",
 			"name" : "0101_The_Expedition_to_Jerusalem",
 			"component" : A101_THE_EXPEDITION_TO_JERUSALEM
 		},
 		{
 			"path" : "/0112_Syria_and_Palestine",
 			"name" : "0112_Syria_and_Palestine",
 			"component" : A112_SYRIA_AND_PALESTINE
 		},
 		{
 			"path" : "/0123_The_First_Settlers",
 			"name" : "0123_The_First_Settlers",
 			"component" : A123_THE_FIRST_SETTLERS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js